import { createUseStyles } from "react-jss";

export default createUseStyles({
    setting: {
        display: "flex",
        alignItems: "center",
        fontSize: "12px",
    },
    settingLabel: {
        flex: 1,
    },
    settingValue: {
        display: "flex",
        margin: [[0, -4]],
    },
});
